import React, { Component } from 'react'

import First from '../block/First'
import PriceList from '../block/PriceList'
import Oblast from '../block/Oblast'
import Feedback from '../block/Feedback'
import News from '../block/News'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const { data, showWindow } = this.props

    return (
      <>
        <First
          bg={data?.first_bg}
          title={data?.first_title}
          text={data?.first_text}
          chipText={data?.first_chipText}
          button1Text={data?.first_button1Text}
          button2Text={data?.first_button2Text}
          scrollText={data?.first_scrollText}
          height={data?.first_height}
          plashka={data?.first_plashka}
          data={data}
        />
        <PriceList data={data} showWindow={showWindow} />
        <Oblast data={data} />
        <Feedback data={data} />
        <News data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App